import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=7b8b0bce&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=ts"
export * from "./Attachment.vue?vue&type=script&lang=ts"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=7b8b0bce&prod&lang=scss&scoped=true"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=7b8b0bce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b0bce",
  null
  
)

export default component.exports